import { LegalDocument } from "@/components/LegalDocument";

export default function Privacy() {
  return <LegalDocument doc="privacy" />;
}
